import React from 'react'
import Navbar from './Navbar'
import Home from './Home'
import About from './About'
import Certificates from './Certificates'
import Memories from './Memories'
import Footer from './Footer'
import Loader from './Loader'
import Projects from './Projects'
import Contact from './Contact'
import Blogs from './Blogs'

function All () {
    return (
        <>
            <Loader />
            <Navbar />
            <Home />
            <About />
            <Certificates />
            <Projects />
            <Blogs />
            <Memories />
            <Contact />
            <Footer />
        </>
    )
}

export default All
